import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalObservables } from '../../../../../app.global.observer';
import { HelperService } from '../../../services/helper.service';
import { Global } from '../../../../../app.global';
import { ReportsService } from '../../../services/reports.service';
import { KeyDescriptionViewModel } from '../../../viewmodels/keyDescriptionViewModel';

import {
  RadioQuestionModel,
  ContraventionQuestionModel,
  SelectQuestionModel,
} from '../../../viewmodels/policy-item.model';
import { ToiletCopy } from '../../../helper/textcopy/policies.text';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'toilet-policy',
  templateUrl: './toilet.component.html',
})
export class ToiletComponent implements OnInit, OnDestroy {
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onSavePolicies = new EventEmitter();
  policiesAnswersSetted = new Subscription();
  policiesAnswers: any = this.global.policiesAnswers;

  textCopy = ToiletCopy;

  cancelling = new RadioQuestionModel();
  contraventions = new ContraventionQuestionModel();
  cancellationsNumber = new SelectQuestionModel();

  constructor(
    public global: Global,
    private globalObs: GlobalObservables,
    private helpServ: HelperService,
    private reportsServ: ReportsService
  ) {}

  ngOnInit() {
    this.setCancellingQuestion();
    this.setContraventionsQuestion();
    this.setCancellationsNumberQuestion();

    if (this.helpServ.isEmpty(this.policiesAnswers)) {
      this.onPoliciesAnswersSetted();
    } else {
      this.setSelectedValues();
    }
  }

  setCancellingQuestion() {
    this.cancelling.data = {
      title: this.textCopy.cancellingTitle,
      includeTitle: true,
      answers: [
        {
          text: 'Yes, we consider and may cancel the PCN',
          value: 'y',
        },
        {
          text: "No, we won't cancel a PCN for this reason",
          value: 'n',
        },
      ],
    };
  }
  onCancellingSelected(answerValue) {
    this.cancelling.valueSelected = answerValue;
  }

  setContraventionsQuestion() {
    this.contraventions = {
      active: true,
      options: [
        { value: 'y', text: 'Y' },
        { value: 'n', text: 'N' },
        { value: 'q', text: 'Q' },
      ],
      valuesSelected: [],
    };
  }
  onContraventionsSelected(answerValue) {
    this.contraventions.valuesSelected = answerValue;
    this.contraventions.valuesSelected = this.contraventions.valuesSelected.slice();
  }

  setCancellationsNumberQuestion() {
    this.cancellationsNumber.data = {
      title: this.textCopy.cancellationsNumberTitle,
      includeTitle: true,
      answers: [
        {
          id: '0',
          value: '1',
        },
        {
          id: '1',
          value: '2',
        },
        {
          id: '2',
          value: '3',
        },
      ],
    };
  }
  onCancellationsNumberSelected(answerValue) {
    this.cancellationsNumber.valueSelected = answerValue;
  }

  setSelectedContraventions() {
    this.reportsServ.getOffences().subscribe((result) => {
      this.contraventions.valuesSelected = [];
      result.forEach((contravention) => {
        // no contravention 15 and 77 for policies
        if (contravention.id === 15 || contravention.id === 77) {
          return;
        }
        const value = this.policiesAnswers[`27_2_${contravention.id}`];
        this.contraventions.valuesSelected.push({
          id: contravention.id,
          value: value !== undefined ? value : 'n',
        });
      });
    });
  }

  setSelectedValues() {
    this.cancelling.valueSelected = this.policiesAnswers['27_1'];
    this.cancellationsNumber.valueSelected = this.policiesAnswers['27_3'];
    this.setSelectedContraventions();
  }

  onPoliciesAnswersSetted() {
    this.policiesAnswers = this.global.policiesAnswers;
    this.policiesAnswersSetted = this.globalObs.onPoliciesAnswersSetted.subscribe(() => {
      this.setSelectedValues();
    });
  }

  submitPolicyCategory() {
    let policyList = new Array<KeyDescriptionViewModel>();
    policyList = [
      { id: '27_1', description: this.cancelling.valueSelected },
      { id: '27_3', description: this.cancellationsNumber.valueSelected },
    ];

    this.contraventions.valuesSelected.forEach((contravention, index) => {
      policyList.push({ id: `27_2_${contravention['id']}`, description: contravention['value'] });
    });

    this.onSavePolicies.emit(policyList);
  }

  ngOnDestroy() {
    if (this.helpServ.isEmpty(this.policiesAnswers)) {
      this.policiesAnswersSetted.unsubscribe();
    }
  }
}
